// test1127
(1127 && 0);
